import React, { useState } from 'react';
import {
  Stack,
  FormControlLabel,
  Switch,
  Box,
  Typography,
  Grid,
} from '@mui/material';

import UploadFile from '../../../shared/UploadFile';
import MultiLineSecretField from '../../../credentials/CredentialsForm/MultiLineSecretField';

export default function DatastoreCredentialField({
  value,
  setValue,
  setChanged,
}) {
  const [uploadFile, setUploadFile] = useState(true);

  const handleUpload = (file) => {
    setChanged();
    setValue(file.contents);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 12, lg: 12 }}>
        <Typography variant='h6'>Credentials</Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 12, lg: 12 }}>
        <Stack spacing={2} direction='row'>
          <FormControlLabel
            control={
              <Switch
                checked={uploadFile}
                onChange={() => setUploadFile(!uploadFile)}
              />
            }
            label='Upload JSON File'
          />
          {uploadFile ? (
            <>
              <UploadFile name={'Credentials JSON'} setValue={handleUpload} />
              <Box sx={{ display: 'flex', flexGrow: 1 }} />
            </>
          ) : (
            <MultiLineSecretField
              label='Credentials JSON'
              value={value}
              setValue={setValue}
              setChanged={setChanged}
            />
          )}
        </Stack>{' '}
      </Grid>
    </Grid>
  );
}
